import React, { useState } from 'react';

interface IAC {
	title: string;
	children?: any;
	selectedName: string;
}

const ChevronIcon = ({ open }: { open: boolean }) => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 24 24'
		fill='none'
		style={{
			transition: 'transform 200ms ease',
			transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
			color: 'var(--color-text-secondary)',
		}}
		aria-hidden='true'
	>
		<path
			d='M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z'
			fill='currentColor'
		/>
	</svg>
);

export const AccordionContainer: React.FC<IAC> = ({ title, children, selectedName }) => {
	const [openTab, setOpenTab] = useState<boolean>(false);
	const hasSelection = !!selectedName;

	return (
		<div
			style={{
				width: '100%',
				boxSizing: 'border-box',
				border: `1px solid ${hasSelection ? 'var(--color-brand-accent)' : 'var(--color-border-default)'}`,
				backgroundColor: 'var(--color-bg-elevated)',
				borderRadius: '14px',
				transition: 'border-color 200ms ease, box-shadow 200ms ease',
				boxShadow: openTab ? 'var(--shadow-md)' : 'none',
			}}
		>
			<button
				type='button'
				onClick={() => setOpenTab(!openTab)}
				aria-expanded={openTab}
				style={{
					all: 'unset',
					cursor: 'pointer',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					width: '100%',
					padding: '16px 18px',
					boxSizing: 'border-box',
					gap: '12px',
				}}
			>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: 0 }}>
					<span
						style={{
							fontFamily: 'var(--font-family-semibold)',
							fontSize: '11px',
							letterSpacing: 'var(--tracking-widest)',
							textTransform: 'uppercase',
							color: 'var(--color-text-tertiary)',
						}}
					>
						{title}
					</span>
					<span
						style={{
							fontFamily: 'var(--font-family-medium)',
							fontSize: 'var(--text-body-size)',
							color: hasSelection ? 'var(--color-text-primary)' : 'var(--color-text-tertiary)',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
						}}
					>
						{hasSelection ? selectedName : 'Tap to choose'}
					</span>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					{hasSelection && !openTab && (
						<span
							aria-hidden
							style={{
								fontFamily: 'var(--font-family-bold)',
								fontSize: '14px',
								color: 'var(--color-brand-accent)',
							}}
						>
							✓
						</span>
					)}
					<ChevronIcon open={openTab} />
				</div>
			</button>
			{openTab ? (
				<div
					style={{
						padding: '0 16px 16px 16px',
						borderTop: '1px solid var(--color-border-subtle)',
						paddingTop: 12,
					}}
				>
					{React.cloneElement(children, { setOpenTab })}
				</div>
			) : null}
		</div>
	);
};
